import { LoyaltyRewardsSection } from "Components/Loyalty/Shared/Rewards/LoyaltyRewardsSection";
import { LoyaltyPointType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

export const RewardsSection = () => {
  const { t } = useResource();

  return (
    <LoyaltyRewardsSection
      pointType={LoyaltyPointType.Valor}
      pointsLabel={t(Resources.Pages.Content.Valor.Rewards.Columns.PointsLabel)}
    />
  );
};
